import BaseApiService from './BaseApiService';
import { apiBaseUrl, publicApiPath } from '../config/ServiceConfig';

/**
 * API service for public endpoints that don't require authentication
 * All requests go to /public/ endpoints and never include auth headers
 */
class PublicApiService extends BaseApiService {
    constructor() {
        super(`${apiBaseUrl}${publicApiPath}`);
    }

    async getRequest(endpoint: string, params?: any): Promise<any> {
        this.logRequest('GET', endpoint);
        try {
            const response = await this.httpClient.get(`${this.baseUrl}${endpoint}`, { params });
            this.logResponse('GET', response.status, response.data);
            return response.data;
        } catch (error) {
            this.handleError(error, 'PublicApiService.GET');
        }
    }

    async postRequest(endpoint: string, data?: any): Promise<any> {
        this.logRequest('POST', endpoint, data);
        try {
            const response = await this.httpClient.post(`${this.baseUrl}${endpoint}`, data);
            this.logResponse('POST', response.status, response.data);
            return response.data;
        } catch (error) {
            this.handleError(error, 'PublicApiService.POST');
        }
    }

    async putRequest(endpoint: string, data?: any): Promise<any> {
        this.logRequest('PUT', endpoint, data);
        try {
            const response = await this.httpClient.put(`${this.baseUrl}${endpoint}`, data);
            this.logResponse('PUT', response.status, response.data);
            return response.data;
        } catch (error) {
            this.handleError(error, 'PublicApiService.PUT');
        }
    }
}

export default PublicApiService;
